import api from '../services/api';
export const ExperienceModel = { fetch: (language) => api.getExperience(language) };
